import * as React from "react"

interface searchProps {
  categorySearchHandler: (e: string) => void
}
export const FolioSearch = ({ categorySearchHandler }: searchProps) => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <div className="duration-300 xl:mt-0 mt-3 z-20 ease-in  xl:w-[5px] xl:hover:w-[220px] hover:rounded-book-free-consultancy xl:!absolute left-0 top-[-23px] bottom-0 right-0 relative xl:shadow-none xl:py-0 lg:py-3 pt-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
      <input
        onChange={(e: any) => categorySearchHandler(e?.target?.value)}
        className={`bg-search w-full !placeholder-opacity-100 pl-7 xl:hover:pl-8 p-5 py-3 font-semibold rounded-book-free-consultancy text-sm outline-none ${theme == "glassy" ? "bg-white" : theme === "light" ? "text-black" : theme === "dark" ? "text-black" : "text-white"}`}
        placeholder="Search Design Category"
        type="text"
      />
      <div className="absolute bottom-3 z-10 w-4 xl:top-[14px] top-[37%] xl:left-3 left-4">
        <svg
          className="w-full search-icon-color"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill=""
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.50162 7.05436C2.50162 4.46702 4.60696 2.36236 7.19429 2.36236C9.78096 2.36236 11.8863 4.46702 11.8863 7.05436C11.8863 9.64169 9.78096 11.747 7.19429 11.747C4.60696 11.747 2.50162 9.64169 2.50162 7.05436ZM14.8316 14.027L11.7656 10.969C12.6696 9.91502 13.2196 8.54902 13.2196 7.05436C13.2196 3.73236 10.5163 1.02902 7.19429 1.02902C3.87162 1.02902 1.16829 3.73236 1.16829 7.05436C1.16829 10.377 3.87162 13.0804 7.19429 13.0804C8.54229 13.0804 9.78429 12.6297 10.789 11.8784L13.8903 14.971L14.8316 14.027Z"
            fill=""
          />
        </svg>
      </div>
    </div>
  )
}
